import ITEMS from "./data/items.json";
import RECIPES from "./data/recipes.json";

export const BASE_MATERIALS = [
  "2691070", // Water
  "2693005", // Lava stone
  "2693015", // Lava stone powder
];

export const FOOD_LABEL = "COOKING";

export const getIconFilePath = (itemId) => `/icons/0${itemId}.info.icon.png`;

export const getAllRecipes = () => {
  return Object.keys(RECIPES).reduce((results, key) => {
    if (BASE_MATERIALS.find((id) => key.includes(id))) {
      return results;
    }
    return [...results, { id: key, ...RECIPES[key], ...getItem(key) }];
  }, []);
};

export const getRecipe = (itemId) => {
  return { id: itemId, ...RECIPES[itemId], ...getItem(itemId) };
};

export const getItem = (itemId) => {
  const rootId = itemId.match(/(\d+)(_\d+)*/)[1];
  return {
    ...ITEMS[rootId],
    icon: getIconFilePath(rootId),
  };
};

export const getIngredients = (itemId, base = false, memoized = {}) => {
  if (!base) {
    const ingredients = RECIPES[itemId].ingredients;
    return Object.keys(ingredients).reduce((results, key) => {
      return [
        ...results,
        { id: key, count: ingredients[key], ...getItem(key) },
      ];
    }, []);
  }

  if (memoized[itemId]) {
    return memoized[itemId];
  }

  const recipe = RECIPES[itemId];
  if (!recipe || BASE_MATERIALS.includes(itemId)) {
    return [{ id: itemId, count: 1, ...getItem(itemId) }];
  }

  const ingredients = recipe.ingredients;

  return Object.keys(ingredients).reduce((results, key) => {
    const multiplier = ingredients[key];
    const baseIngredients = getIngredients(key, true);
    memoized[key] = baseIngredients;
    baseIngredients.forEach((i) => (i.count = i.count * multiplier));
    const nextResults = [...results, ...baseIngredients];
    return aggregateIngredientCount(nextResults);
  }, []);
};

export const aggregateIngredientCount = (ingredientList) => {
  const aggregatedResults = ingredientList.reduce((aggregated, result) => {
    const { id, count, ...rest } = result;
    if (typeof aggregated[id] === "undefined") {
      aggregated[id] = { id, count, ...rest };
    } else {
      aggregated[id].count += count;
    }
    return aggregated;
  }, {});
  return Object.keys(aggregatedResults).reduce((results, key) => {
    return [...results, aggregatedResults[key]];
  }, []);
};
